import { useEffect, useState } from "react";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import { SpectroCom } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import Button from "../../common/Button";

const Spectro = () => {
  const userId = sessionStorage.getItem("userId");
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    components_Id: 0,
    components_Name: "",
    created_By: 1,
  });

  const [loading, setLoading] = useState(false);
  const [isSpectroData, setIsSpectroData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;

  const fetchSpectroData = async () => {
    setLoading(true);
    try {
      const res = await SpectroCom.getAllSpectro(currentPage, pageSize);
      setIsSpectroData(res.items || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSpectroData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isSpectroData);
    } else {
      const filtered = isSpectroData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isSpectroData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    setIsModelOpen(true);
    setIsEditing(false);
    setFormData({
      components_Id: 0,
      components_Name: "",
      created_By: 1,
    });
  };

  const handleEdit = async (id) => {
    try {
      const data = await SpectroCom.getById(id);
      if (data) {
        setFormData({
          components_Id: data.components_Id,
          components_Name: data.components_Name,
          Modify_By: 1,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await SpectroCom.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchSpectroData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    try {
      await SpectroCom.saveOrUpdate(formData);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success"
      );
      fetchSpectroData();
      setFormData({
        components_Id: 0,
        components_Name: "",
        created_By: 1,
      });
      setIsEditing(false);
      if (!resetOnly) {
        setIsModelOpen(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    }
  };

  const fields = [
    {
      name: "components_Name",
      label: "component Name",
      type: "text",
      required: true,
      errorMessage: "Name is required",
    },
  ];

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5  mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              ></Button>
            )}
          </div>
          <Button
            text="Add Spectro"
            className="bg-orange text-black font-semibold text-md rounded-md p-2"
            iconSpacing="pr-2"
            icon={HiOutlinePlus}
            iconColor="text-black"
            onClick={handleAdd}
          />
        </div>

        {loading ? (
          <Loader />
        ) : (
          <Table
            columns={[{ key: "components_Name", label: "component Name" }]}
            data={filteredData}
            onEdit={(row) => handleEdit(row.components_Id)}
            onDelete={(row) => handleDelete(row.components_Id)}
          />
        )}

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Sepctro " : "Add Sepctro "}
      >
        <FormFields
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: false });
          }}
          onSubmitAndAddNew={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: true });
          }}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={fields}
          isEditing={isEditing}
          onClear={() => setIsModelOpen(false)}
        />
      </Model>

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default Spectro;
